import React, { useState, useContext } from "react";
import { CustomModal } from "../../../components/CustomModal";
import BackgroundModal from "./modals/backgroundModal/backgroundModal";
import { useMutation, useQuery } from "@tanstack/react-query";
import { getStaticExpertFields, updateExpert } from "../../../service/api";
import FileKeysContext from "../../../context/fileKeysContext";
import { useQueryClient } from "@tanstack/react-query";
import UploadingProcessContext from "../../../context/uploadingProcessContext";
import ExpertField from "./modals/backgroundModal/ExpertField";
import AcContext from "../../../context/activityConsultingContext";

function Background({ data, expertDataQuery }) {
  const queryClient = useQueryClient();
  const [openModal, setOpenModal] = useState(false);
  const [openMiniModal, setOpenMiniModal] = useState(false);
  const [openFieldModal, setOpenFieldModal] = useState(false);
  const [loading,setLoading] = useState()
  const consultingFields = data?.consultingFields;
  let w = document.documentElement.clientWidth || window.innerWidth;
  const { expertPageCoverKey, resetFileKeysContext } =
    useContext(FileKeysContext);
  const { resetUploadingProcessContext } = useContext(UploadingProcessContext);

  const query = useQuery(["staticsExpertFields"], getStaticExpertFields);
  const { consultingFieldsIds, activityFieldsIds } = useContext(AcContext);
  const modalHandler = () => {
    resetUploadingProcessContext();
    resetFileKeysContext();
    if (w > 640) {
      setOpenModal(true);
    } else if (w <= 640) {
      setOpenMiniModal(true);
    }
  };

  //symbols
  const symbolId = data?.symbolId;
  const expertSymbols = query?.data?.EXPERTS_SYMBOLS;
  const symbolFinder = expertSymbols?.find((item) => item?.id === symbolId);
  //

  //badges
  const badgeIds = data?.badgesIds;
  const expertBadges = query?.data?.EXPERTS_BADGES;
  const badgeFinder = expertBadges?.filter((expertBadge) =>
    badgeIds?.includes(expertBadge?.id)
  );

  const mutation = useMutation(updateExpert, {
    onError:()=>{
      setOpenModal(true);
      setOpenFieldModal(true)
      setLoading(false)

    },
    onSuccess: () => {
      queryClient.invalidateQueries(["expertData"]);
      setOpenModal(false);
      setOpenFieldModal(false)
      setLoading(false)
    },
    onMutate:()=>{
setLoading(true)
    }
  });

  const onOk = () => {
    if (expertPageCoverKey === "") {
    } else {
      mutation.mutate({ cover: expertPageCoverKey });
    }
  };

  const sendAC = () => {
          mutation.mutate({
        activityFieldsIds: activityFieldsIds,
        consultingFieldsIds: consultingFieldsIds,
      });

  };
  return (
    <div className=" w-full relative rounded-3xl hover:brightness-80 hover:shadow-xl cursor-pointer ">
      <div
        onClick={modalHandler}
        style={{
          backgroundImage: `url(${
            data?.cover?.startsWith("http")
              ? data?.cover
              : process.env.REACT_APP_ARVAN_S3_BASE_URL + data?.cover
          })`,
        }}
        className="flex h-72 z-10 flex-col bg-cover bg-no-repeat rounded-3xl max-lg:rounded-none overflow-hidden justify-between max-lg:h-[12rem]"
      >
        <div className="flex flex-row justify-between m-4 ">
          <img
            className={` ${
              symbolFinder?.iconLargeURL ? "visible" : "invisible"
            } w-1/6 max-lg:w-[4.5rem] max-lg:h-[1.5rem]`}
            alt="img"
            src={symbolFinder?.iconLargeURL}
          />
          <div className="flex felx-row gap-4">
            {badgeFinder?.map((url) => {
              return (
                <img
                  alt="badge"
                  hidden
                  className={`  ${
                    url.iconURL ? "visible" : "invisible"
                  } w-[3.5rem] max-lg:w-[1.79556rem] max-lg:h-[1.875rem]`}
                  src={url.iconURL}
                />
              );
            })}
          </div>
        </div>
      </div>
      <div
        onClick={() => {
          setOpenFieldModal(true);
        }}
        className="text-left mt-[-2.72rem] rounded-b-3xl flex flex-row justify-end z-20 font-body group  text-white text-lg max-lg:text-[10px] hover:bg-[rgba(255,255,255,0.17)] bg-[rgba(0,0,0,0.59)] p-2  gap-2"
      >
        <p>زمینه مشاوره:</p>
        {consultingFields?.map((data, i) => {
          return (
            <p className="font-body  text-white text-lg font-medium  max-lg:text-[10px]  ">
              {i === 0 ? "" : "/"}
              {data?.name.replace("مشاوره", "")}
            </p>
          );
        })}
      </div>
      {openModal && (
        <CustomModal
          onOk={onOk}
          loading={loading}
          size={"50vw"}
          handleCancel={() => {
            setOpenModal(false);
          }}
          visible={openModal}
        >
          <BackgroundModal />
        </CustomModal>
      )}

      {openMiniModal && (
        <CustomModal
          onOk={onOk}
          size={"100vw"}
          handleCancel={() => {
            setOpenMiniModal(false);
          }}
          visible={openMiniModal}
        >
          <BackgroundModal />
        </CustomModal>
      )}

      {openFieldModal && (
        <CustomModal
          onOk={sendAC}
          loading={loading}
          size={"50vw"}
          handleCancel={() => {
            setOpenFieldModal(false);
          }}
          visible={openFieldModal}
        >
          <ExpertField
            statics={query?.data}
            expertDataQuery={expertDataQuery}
          />
        </CustomModal>
      )}
    </div>
  );
}

export default Background;
